module.exports = __webpack_public_path__ + "img/birth.abc7f5e1.svg";